import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';

const StyledTypography = styled(Typography)({
  textAlign: 'right',
  width: '20rem',
});

export default StyledTypography;
